import { createContext, useContext } from 'react'
import type { LayoutService } from './services'
import type { PageService } from './services/pageService'
import type { ArticleService } from './services/articleService'
import type { ArtifactService } from './services/artifactService'
import type { AdminService } from './services/adminService'

// ─── Shape of what the context exposes ───────────────────────────────────────

export interface Services {
  layoutService: LayoutService
  pageService: PageService
  articleService: ArticleService
  artifactService: ArtifactService
  adminService: AdminService
}

// ─── Context ──────────────────────────────────────────────────────────────────

export const ServiceContext = createContext<Services | null>(null)

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useServices(): Services {
  const ctx = useContext(ServiceContext)
  if (!ctx) throw new Error('useServices must be used within a ServiceProvider')
  return ctx
}
